module.exports = __webpack_public_path__ + "static/media/BryanMills.78f768e9.png";